import React from 'react';
import { BsBuilding } from 'react-icons/bs';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import './testimonials.css';

const Testimonials = () => {
  const experiences = [
    {
      id: 1,
      company: 'Aerawat Crop',
      role: 'Frontend Developer Intern',
      duration: 'Jan 2025 - Apr 2025',
      location: 'Onsite, Lalitpur',
      description: 'Worked as a frontend developer intern, building responsive UI components and collaborating with the team on project development.',
    },
    {
      id: 2,
      company: 'Samrat Movies Pvt Ltd',
      role: 'Full Stack Developer',
      duration: 'Sep 2025 - Present',
      location: 'Samakhusi, Kathmandu',
      description: 'Developing full-stack features for the company, maintaining both frontend and backend systems, and implementing real-time functionalities.',
    },
  ];

  return (
    <section id="experiences">
      <h5>My Career Journey</h5>
      <h2>Experiences</h2>

      <Swiper
        className="container experiences__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {experiences.map((exp) => (
          <SwiperSlide className="experience" key={exp.id}>
            <div className="company__icon">
              <BsBuilding />
            </div>
            <h5 className="company__name">{exp.company}</h5>
            <small className="company__role">{exp.role}</small>
            <p className="company__duration">{exp.duration} | {exp.location}</p>
            <p className="company__description">{exp.description}</p>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
